import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private toastr: ToastrService) {}

  /**
   * Show success message
   */
  success(message: string, title?: string): void {
    this.toastr.success(message, title || 'Success');
  }

  /**
   * Show error message
   */
  error(message: string, title?: string): void {
    this.toastr.error(message, title || 'Error');
  }

  /**
   * Show warning message
   */
  warning(message: string, title?: string): void {
    this.toastr.warning(message, title || 'Warning');
  }

  /**
   * Show info message
   */
  info(message: string, title?: string): void {
    this.toastr.info(message, title || 'Info');
  }

  /**
   * Clear all toasts
   */
  clear(): void {
    this.toastr.clear();
  }
} 